import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { IOExtension } from 'z3k-config';
import { Z3KSettings, Z3KSettingsEditor } from '../../provider/types';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
import { unpack_validation } from 'z3k-parser/validation/types';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { isShownIoExtensionList } from '../io-extensions';
import { removeNulls } from 'utils';
export function ServicePage() {
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec, service_view, is_climatic, is_staff } = useContext(Z3KSettings);
    const io_extensions_count = useMemo(() => IOExtension.get.where(config, IOExtension.countMaxAmount).length, [config.io_extensions]);
    const hide_add_button = useMemo(() => device_spec.io.max_amount_io_extensions != null
        ? io_extensions_count >= device_spec.io.max_amount_io_extensions
        : false, [device_spec, io_extensions_count]);
    const show_list = useMemo(() => isShownIoExtensionList(service_view, config, device_spec, is_staff, is_climatic), [device_spec, service_view]);
    const childrenItem = useCallback((selected_item_id) => {
        if (device_spec.io.io_extensions_supported) {
            return (show_list && (_jsx(DragDropDrawer, { z3k_name: "io_extensions", name: RouteNaming[Z3kSecondRoutes.io_extensions], help_id: "io_extensions", item_url: Z3kSecondRoutes.io_extensions, enableDnd: true, objectFilter: IOExtension.shownToUser, hideAddButton: hide_add_button, selected_item_id: selected_item_id })));
        }
        return null;
    }, [device_spec, show_list, hide_add_button]);
    const findId = useCallback((item_key, item_id, findInConfig) => {
        return ((!item_id || !findInConfig) &&
            item_key != Z3kSecondRoutes.configuration &&
            item_key != Z3kSecondRoutes.device_maintenance);
    }, []);
    const customButtons = useMemo(() => removeNulls([
        Z3kSecondRoutes.configuration,
        device_spec.has_maintenance ? Z3kSecondRoutes.device_maintenance : null,
    ]), [device_spec]);
    return (_jsx(Z3kDragDropContainer, { findId: findId, customButtons: customButtons, childrenItem: childrenItem }));
}
const fields = ['io_extensions'];
ServicePage.isError = (validation_result) => fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
ServicePage.isWarning = ServicePage.isError;
ServicePage.isShown = (is_service_view, config, spec, is_staff, is_climatic) => !Z3K_IS_USB_UTILITY && (spec.has_service_mode ? is_service_view : true);
